/** Kept in sync with `validatePassword` / `getPasswordErrorMessage` checks. */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export const MIN_PASSWORD_LENGTH = 8

const HAS_AT_LEAST_ONE_NUMBER = /[0-9]+/
const HAS_AT_LEAST_ONE_UPPERCASE = /[A-Z]+/
const HAS_AT_LEAST_ONE_LOWERCASE = /[a-z]+/
const HAS_AT_LEAST_ONE_SPECIAL_CHARACTER = /[!@#$%^&*()\[\]{};':"\\|,.<>/?~`+=^%-]/
const HAS_WHITESPACE = /\s/

/**
 * Validates if a password meets all security requirements
 *
 * @param {string} password - The password to validate
 * @returns {boolean} - True if the password meets all requirements, false otherwise
 */
export default function validatePassword(password: string): boolean {
  return (
    password.length >= MIN_PASSWORD_LENGTH &&
    HAS_AT_LEAST_ONE_NUMBER.test(password) &&
    HAS_AT_LEAST_ONE_UPPERCASE.test(password) &&
    HAS_AT_LEAST_ONE_LOWERCASE.test(password) &&
    !HAS_WHITESPACE.test(password) &&
    HAS_AT_LEAST_ONE_SPECIAL_CHARACTER.test(password)
  )
}

/**
 * Gets a specific error message for why a password is invalid
 *
 * @param {string} password - The password to check
 * @returns {string|null} - Error message or null if password is valid
 */
export function getPasswordErrorMessage(password: string): string | null {
  if (!password) {
    return "Password is required"
  }

  if (HAS_WHITESPACE.test(password)) {
    return "Password cannot contain any white space"
  }

  if (password.length < MIN_PASSWORD_LENGTH) {
    return "Password must be at least 8 characters long"
  }

  if (!HAS_AT_LEAST_ONE_NUMBER.test(password)) {
    return "Password must contain at least one number"
  }

  if (!HAS_AT_LEAST_ONE_UPPERCASE.test(password)) {
    return "Password must contain at least one uppercase letter"
  }

  if (!HAS_AT_LEAST_ONE_LOWERCASE.test(password)) {
    return "Password must contain at least one lowercase letter"
  }

  if (!HAS_AT_LEAST_ONE_SPECIAL_CHARACTER.test(password)) {
    return "Password must contain at least one special character"
  }

  return null
}
